// TODO(): type OutputAction payloads
export enum OutputAction {
  Handshake = 'Handshake',
  Logout = 'Logout',
  Downloads_GetAll = 'Downloads_GetAll',
  Download_Start = 'Download_Start',
  Download_Delete = 'Download_Delete',
  Download_Pause = 'Download_Pause',
  Download_Resume = 'Download_Resume',
  Download_Play = 'Download_Play',
  Settings_GetAll = 'Settings_GetAll',
  Settings_DownloadQuality = 'Settings_DownloadQuality',
  Settings_DownloadWifi = 'Settings_DownloadWifi',
}
